export default __webpack_public_path__ + "static/media/default-img.70ddfa92.png";